import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content flex-row-fluid" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Cài đặt thủ tục nhập học", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-5" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_10 = { class: "breadcrumb-item text-muted" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-header border-0 pt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Danh sách phí khác")
], -1)
const _hoisted_15 = { class: "card-toolbar" }
const _hoisted_16 = {
  class: "justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_17 = { class: "svg-icon svg-icon-2" }
const _hoisted_18 = {
  type: "button",
  class: "btn btn-sm btn-light-primary d-none",
  "data-bs-toggle": "modal",
  ref: "kt_modal_add_combination",
  "data-bs-target": "#kt_modal_add_combination"
}
const _hoisted_19 = { class: "card-body umt-form pt-0" }
const _hoisted_20 = { class: "d-flex flex-center gap-5" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  class: "svg-icon svg-icon-2",
  style: {"opacity":".7"}
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  class: "svg-icon svg-icon-2 svg-icon-danger",
  style: {"opacity":".6"}
}
const _hoisted_25 = {
  class: "modal fade",
  id: "kt_modal_add_combination",
  ref: "addCombinationModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_26 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_27 = { class: "modal-content" }
const _hoisted_28 = {
  class: "modal-header p-3",
  id: "kt_modal_add_customer_header"
}
const _hoisted_29 = { class: "fw-bolder" }
const _hoisted_30 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_31 = { class: "svg-icon svg-icon-1" }
const _hoisted_32 = { class: "modal-body py-4 px-lg-6" }
const _hoisted_33 = { class: "d-flex gap-5 mb-3" }
const _hoisted_34 = { class: "fv-row flex-md-root" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tên phí khác", -1)
const _hoisted_36 = { class: "fv-row flex-md-root" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Giá trị", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 text-center" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary m-auto",
    type: "submit"
  }, " Lưu ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
            [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW, _ctx.Permission.DASHBOARD]]
          ]),
          _hoisted_9,
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "/caidatthutucnhaphoc",
              class: "text-muted text-hover-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cài đặt thủ tục nhập học ")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-light ms-auto umt-btn-32",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, [
          _hoisted_11,
          _createTextVNode("Quay lại ")
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.callModalAddApp && _ctx.callModalAddApp(...args)))
              }, [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
                ]),
                _createTextVNode(" Thêm phí khác ")
              ]),
              _createElementVNode("button", _hoisted_18, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            total: _ctx.tableData.length,
            currentPage: _ctx.pagination.currentPage,
            "table-header": _ctx.tableHeader,
            "rows-per-page": _ctx.pagination.limit,
            "enable-items-per-page-dropdown": false
          }, {
            "cell-id": _withCtx(({ row: customer }) => [
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(customer.id), 1)
              ])
            ]),
            "cell-name": _withCtx(({ row: customer }) => [
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(customer.name), 1)
              ])
            ]),
            "cell-fee": _withCtx(({ row: customer }) => [
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(customer.fee.toLocaleString('vi-VN')), 1)
              ])
            ]),
            "cell-actions": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", {
                  onClick: ($event: any) => (_ctx.setDataForm(customer)),
                  class: "menu-link cursor-pointer"
                }, [
                  _createElementVNode("span", _hoisted_22, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen58.svg" })
                  ])
                ], 8, _hoisted_21),
                _createElementVNode("span", {
                  class: "menu-link cursor-pointer",
                  onClick: ($event: any) => (_ctx.deleteRow(customer))
                }, [
                  _createElementVNode("span", _hoisted_24, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/remove-file.svg" })
                  ])
                ], 8, _hoisted_23)
              ])
            ]),
            _: 1
          }, 8, ["table-data", "total", "currentPage", "table-header", "rows-per-page"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("h2", _hoisted_29, _toDisplayString(_ctx.isEdit ? "Chỉnh sửa phí khác" : "Thêm phí khác"), 1),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("span", _hoisted_31, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.formData,
              ref: "formRef",
              rules: _ctx.rules
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createVNode(_component_el_form_item, { prop: "name" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            class: "form-select-solid w-100",
                            placeholder: "Tên phí khác",
                            modelValue: _ctx.formData.name,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.name) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createVNode(_component_el_form_item, { prop: "fee" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            class: "form-select-solid w-100",
                            placeholder: "Giá trị phí khác",
                            modelValue: _ctx.formData.fee,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.fee) = $event)),
                            modelModifiers: { number: true }
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_38
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ])
    ], 512)
  ], 64))
}